import requestor from "requestor";

import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default createReduxPromiseAction(
  ActionTypes.DOCUMENT_CLAUSEPART_ADDITION_REVERT,
  (
    organisationId,
    projectId,
    documentId,
    sectionId,
    clauseId,
    clausepartId,
    lastEdited,
  ) =>
    requestor
      .post(
        `${basePath}/organisation/${organisationId}` +
          `/project/${projectId}` +
          `/document/${documentId}` +
          `/section/${sectionId}` +
          `/clause/${clauseId}` +
          `/clausepart/${clausepartId}/revert-addition`,
        {last_edited: lastEdited},
        {withCredentials: true},
      )
      .then(response => response.data),
);
